/** Where the operator lands after ending an inspection.
 *
 * Reported 2026-09-27: it always went to the dashboard, so after every
 * call the operator had to navigate back to whatever they were working
 * through. Return them to the list they came from instead:
 *
 *   campaign inspection → that campaign's beneficiary list, where the
 *                         next person to call is already on screen
 *   standalone          → the inspection list
 *
 * A pure function rather than an inline ternary so the rule can be
 * tested without mounting the whole session page.
 */
export function endSessionReturnPath(session: {
  campaign?: string | null;
}): string {
  const campaign = session.campaign;
  return campaign
    ? `/campaigns/${campaign}?tab=beneficiaries`
    : "/sessions";
}
